"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _OnlyHeaderLayout = require("./OnlyHeaderLayout");
Object.keys(_OnlyHeaderLayout).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OnlyHeaderLayout[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OnlyHeaderLayout[key];
    }
  });
});
var _OnlyHeaderServices = require("./OnlyHeaderServices");
Object.keys(_OnlyHeaderServices).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OnlyHeaderServices[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OnlyHeaderServices[key];
    }
  });
});
var _types = require("./types");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _types[key];
    }
  });
});
